import { DashboardGuard } from './dashboard.guard';
import { PlatformAccessGuard } from './platform-access.guard';

export const guards = [DashboardGuard, PlatformAccessGuard];

export * from './dashboard.guard';
export * from './platform-access.guard';
